export default __webpack_public_path__ + "static/media/fun.30974d17.jpg";